module.exports = __webpack_public_path__ + "img/人体感应.a84ea301.jpg";